import { defineMessages } from 'react-intl';

const messages = defineMessages({
  orderNumber: {
    description: 'advancedSearch.orders.filters.orderNumber',
    defaultMessage: 'Order #',
    id: 'iptX24',
  },
});

export default messages;
